/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, cx, jsx } from '@atlaskit/css';
import { akEditorFullWidthLayoutWidth } from '@atlaskit/editor-shared-styles';
import AddIcon from '@atlaskit/icon/core/add';
import { Box, Pressable } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

const styles = cssMap({
	containerBaseStyles: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	lineStyles: {
		flex: 1,
		height: '3px',
		backgroundColor: token('color.background.neutral.bold'),
	},
	pressable: {
		backgroundColor: token('color.background.neutral.bold'),
		borderRadius: token('border.radius.circle'),
		height: '32px',
		width: '32px',
		'&:hover': {
			backgroundColor: token('color.background.neutral.bold.hovered'),
		},
		'&:active': {
			backgroundColor: token('color.background.neutral.bold.pressed'),
		},
	},
});

const Line = () => <Box xcss={cx(styles.lineStyles)} />;

interface PlusButtonProps {
	onClick: (event: React.MouseEvent) => void;
}

export const PlusButton = ({ onClick }: PlusButtonProps) => {
	const containerDynamicStyles = {
		// add 40px to the max width to account for the padding of the editor
		maxWidth: `${akEditorFullWidthLayoutWidth + 40}px`,
	};
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		<div
			css={styles.containerBaseStyles}
			style={containerDynamicStyles}
			data-testid="company-hub-plus-button"
		>
			<Line />
			<Tooltip content="Add section">
				{(tooltipProps) => (
					<Pressable
						{...tooltipProps}
						onClick={onClick}
						xcss={styles.pressable}
						aria-label="Add section"
					>
						<AddIcon label="" color={token('color.icon.inverse')} />
					</Pressable>
				)}
			</Tooltip>
			<Line />
		</div>
	);
};
